// Lightweight analytics shim for the onboarding funnel. Pushes to a GTM-style
// dataLayer when present (web) and is a safe no-op otherwise. Single place to
// wire a real analytics provider later.
export type OnboardingEvent =
  | "onboarding_brand_submitted"
  | "onboarding_creators_viewed"
  | "onboarding_plans_viewed"
  | "plan_hired"
  | "onboarding_started_free"
  | "onboarding_completed_with_existing_plan"
  | "onboarding_brand_configured"
  | "onboarding_brand_config_skipped"
  | "onboarding_payment_confirmed"
  | "onboarding_payment_unconfirmed";

type DataLayerWindow = {
  dataLayer?: { push: (entry: Record<string, unknown>) => void };
};

export const trackOnboardingEvent = (
  event: OnboardingEvent,
  properties: Record<string, unknown> = {},
): void => {
  if (typeof window === "undefined") return;
  const layer = (window as DataLayerWindow).dataLayer;
  layer?.push({ event, ...properties });
};
